// Detect TV-news helicopter operators from raw operator strings (airplanes.live).
// Conservative allowlist — false positives ("ABC Aviation Services") are worse
// than false negatives, since the news templates rib news copters specifically.

const NEWS_ORGS = [
  { label: 'ABC News',     patterns: [/\babc\s*news\b/i] },
  { label: 'NBC News',     patterns: [/\bnbc\s*news\b/i, /\bwnbc\b/i] },
  { label: 'CBS News',     patterns: [/\bcbs\s*news\b/i, /\bcbs\s*broadcast/i, /\bwcbs\b/i] },
  { label: 'Fox 5',        patterns: [/\bfox\s*5\b/i, /\bwnyw\b/i] },
  { label: 'News 12',      patterns: [/\bnews\s*12\b/i] },
  { label: 'PIX11',        patterns: [/\bpix\s*11\b/i, /\bwpix\b/i] },
  { label: 'WABC',         patterns: [/\bwabc\b/i] },
  { label: 'NY1',          patterns: [/\bny1\b/i] },
  { label: 'Spectrum News', patterns: [/\bspectrum\s*news\b/i] },
];

export function isNewsOperator(operator) {
  return newsOrgFromOperator(operator) !== null;
}

export function newsOrgFromOperator(operator) {
  if (!operator || typeof operator !== 'string') return null;
  for (const org of NEWS_ORGS) {
    if (org.patterns.some((re) => re.test(operator))) return org.label;
  }
  return null;
}
